'use strict';

angular.module('webAgro1App').factory('EmpreendimentosService', function($http) {
  return {
    list: function(params) {
      return $http.get(SERVER + 'v1/empreendimentos', { params });
    }
  };
});
